import axios from "axios";
import authHeader from '../../../authheader'

const EFRENEWALURL = process.env.REACT_APP_APIURL + "/api/FirmEfRenewal";

const getViolation = (renewalId) => {
    return axios.get(`${EFRENEWALURL}/violation`, { headers: authHeader(), params: { renewalId } });
}
const postViolation = (data) => {
    return axios.post(`${EFRENEWALURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}